import React from 'react';
import { Box, FormControlLabel, Typography } from '@mui/material';
import moment from 'moment';
import 'moment/locale/pt-br';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { DeleteOutlined } from '@mui/icons-material';
import { textToLowerCase } from '../../../Utils/format';
import LoaderMain from '../../../Shared/LoaderMain';
import IOSSwitch from '../shared/IOSSwitch';
import ButtonMain from '../../../Shared/ButtonMain';

const DefinicaoDeColunas = (
  excluirInativarDocumento,
  downloadArquivo,
  abrirModalDocumentos,
  cliente,
  escopoClienteDados
) => {
  const [isPendingGrid, setIsPendingGrid] = React.useState([]);

  const config = [
    {
      field: 'STATUS',
      headerName: cliente.formalizado ? 'Status' : 'Excluir',
      flex: 1,
      minWidth: 50,
      maxWidth: 100,
      headerClassName: 'data-grid-header-centralizado font-bold-header',
      cellClassName: 'items-centralizados data-grid-light-gray texto-centro',
      renderCell: params => (
        <>
          {cliente.formalizado ? (
            <FormControlLabel
              className="margin-zero"
              control={<IOSSwitch disabled={!escopoClienteDados.permite_alterar} />}
              onClick={e => excluirInativarDocumento(params.row.id, e)}
              checked={params.row.STATUS === 'A'}
            />
          ) : (
            <ButtonMain
              size="small"
              variant="outlined"
              className="botao-alterar-excluir"
              onClick={() => excluirInativarDocumento(params.row.id)}
              disabled={!escopoClienteDados.permite_excluir}
            >
              <DeleteOutlined />
            </ButtonMain>
          )}
        </>
      )
    },
    {
      field: 'NOMETIPOARQUIVO',
      headerName: 'Tipo de documento',
      flex: 1,
      minWidth: 200,
      headerClassName: 'data-grid-header-centralizado font-bold-header',
      cellClassName: 'data-grid-light-gray camel-case border-radius-left',
      renderCell: params => (
        <>
          <Box className="box-icone-formalizacao">
            <FilePresentIcon />
          </Box>
          {params.row.NOMETIPOARQUIVO}
        </>
      )
    },
    {
      field: 'ENVIARFUNDO',
      headerName: 'Enviar para Fundo',
      flex: 1,
      minWidth: 140,
      headerClassName: 'data-grid-header-centralizado font-bold-header',
      cellClassName: 'items-centralizados data-grid-light-gray',
      renderCell: params => <>{params.row.ENVIARFUNDO === 'S' ? 'Sim' : 'Não'}</>
    },
    {
      field: 'ASSINADO',
      headerName: 'Assinado',
      flex: 1,
      minWidth: 140,
      headerClassName: 'data-grid-header-centralizado font-bold-header',
      cellClassName: 'items-centralizados data-grid-light-gray text-transform-capitalize',
      renderCell: params => <>{params.row.ASSINADO === 'S' ? 'Sim' : 'Não'}</>
    },
    {
      field: 'NOMEARQUIVO',
      headerName: 'Arquivo',
      flex: 1,
      minWidth: 200,
      headerClassName: 'data-grid-header-centralizado font-bold-header',
      cellClassName: 'items-centralizados data-grid-light-gray',
      renderCell: params => (
        <Box
          className="icone-arquivo-download"
          onClick={() => downloadArquivo(params.row.id, setIsPendingGrid, isPendingGrid)}
          sx={isPendingGrid[params.row.id] ? { position: 'relative' } : {}}
        >
          {isPendingGrid[params.row.id] && (
            <LoaderMain tipoLoader="float" tipoImagem="circulo" tamanho="md" percentTop="5%" />
          )}
          <Box className="icon">
            <AttachFileIcon sx={{ fontSize: '20px' }} />
          </Box>
          <Box className="text">{textToLowerCase(params.row.NOMEARQUIVO)}</Box>
        </Box>
      )
    },
    {
      field: 'DTHRINSERT',
      headerName: 'Inclusão',
      flex: 1,
      minWidth: 120,
      headerClassName: 'data-grid-header-centralizado font-bold-header',
      cellClassName: 'items-centralizados data-grid-light-gray text-transform-capitalize',
      renderCell: params => (
        <Typography
          className="texto-centro flex-box-items-centralizados items-centralizados"
          variant="h7"
          title={moment(params.row.DTHRINSERT).format('DD/MM/yyyy HH:mm:ss')}
        >
          {moment(params.row.DTHRINSERT).format('DD/MM/yyyy')}
        </Typography>
      )
    }
  ];

  if (escopoClienteDados && escopoClienteDados.permite_alterar) {
    const abrirModal = {
      field: 'abrir_cliente',
      headerName: '',
      flex: 1,
      maxWidth: 100,
      minWidth: 80,
      headerClassName: 'data-grid-header-centralizado font-bold-header',
      cellClassName: 'items-centralizados data-grid-light-gray border-radius-right',
      renderCell: params => (
        <Typography
          className="novas-entradas-abrir"
          variant="h7"
          onClick={() => abrirModalDocumentos(false, params.row)}
        >
          Abrir
          <ChevronRightIcon sx={{ fontSize: '20px' }} />
        </Typography>
      )
    };

    config.push(abrirModal);
  }

  return config;
};

export default DefinicaoDeColunas;
